import { useState, useEffect } from "react";
import UnderMaintenanceImage from "static/assets/img/underMaintenance.svg";
import dayjs from "dayjs";
import duration from "dayjs/plugin/duration"; // Import the duration plugin
import "index.css";

dayjs.extend(duration);

const UnderMaintenance = ({ data }) => {
  const [showTimer, setShowTimer] = useState(false);
  const [h, setHoure] = useState("");
  const [m, setMinutes] = useState("");
  const [s, setSeconds] = useState("");
  const getTime = (dueDate) => {
    if (dueDate) {
      const currentDate = dayjs();
      const closeDate = dayjs(dueDate);
      const dur = dayjs.duration(closeDate.diff(currentDate));
      if (dur < 0) {
        setShowTimer(false);
        return null;
      }
      const hours = dur.hours();
      const minutes = dur.minutes();
      const seconds = dur.seconds();
      setShowTimer(true);
      return { hours, minutes, seconds };
    } else {
      setShowTimer(false);
      return null;
    }
  };

  const handleTime = (value, label) => {
    return (
      <div className="under-maintenance-page-timer-card">
        <span className="under-maintenance-page-timer-time">{value}</span>
        <span className="under-maintenance-page-timer-label">{label}</span>
      </div>
    );
  };

  useEffect(() => {
    const interval = setInterval(() => {
      const timeObject = getTime(data?.expiryDate);
      if (timeObject) {
        const { hours, minutes, seconds } = timeObject;
        setHoure(hours > 9 ? hours : `0${hours}`);
        setMinutes(minutes > 9 ? minutes : `0${minutes}`);
        setSeconds(seconds > 9 ? seconds : `0${seconds}`);
      }
    }, 1000);
    return () => clearInterval(interval);
  }, [data]);

  return (
    <div className="under-maintenance-page">
      <img src={UnderMaintenanceImage} alt="under-maintenance" />
      {showTimer && (
        <div className="under-maintenance-page-timer">
          {handleTime(h, "ساعة")}
          {handleTime(m, "دقيقة")}
          {handleTime(s, "ثانية")}
        </div>
      )}
      <span
        className="under-maintenance-main-text"
        style={{ marginTop: showTimer ? "0rem" : "3rem" }}
      >
        المنصة تحت الصيانة...
      </span>
      <span className="under-maintenance-description">{data?.message}</span>
    </div>
  );
};

export default UnderMaintenance;
